"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = buildSameDifferentTimeline;
// setup
require("regenerator-runtime/runtime");
const taskSetup_1 = require("../taskSetup");
const helpers_1 = require("../shared/helpers");
const taskSetup_2 = require("../taskSetup");
// trials
const dataQuality_1 = require("../shared/trials/dataQuality");
const trials_1 = require("../shared/trials");
const afcMatch_1 = require("./trials/afcMatch");
const stimulus_1 = require("./trials/stimulus");
const legacyStimulus_1 = require("./trials/legacyStimulus");
const taskStore_1 = require("../../taskStore");
const setTrialBlock_1 = require("./helpers/setTrialBlock");
const batchPreloading_1 = require("../shared/helpers/batchPreloading");
function buildSameDifferentTimeline(config, mediaAssets) {
    const heavy = (0, taskStore_1.taskStore)().heavyInstructions;
    let corpus = (0, taskStore_1.taskStore)().corpora.stimulus;
    if (!heavy && (0, taskStore_1.taskStore)().version === 2) {
        corpus = corpus.filter((trial) => {
            return !(trial.trialType.includes('something-same') && !(trial.assessmentStage === 'practice_response'));
        });
        (0, taskStore_1.taskStore)('corpora', {
            practice: (0, taskStore_1.taskStore)().corpora.practice,
            stimulus: corpus,
        });
    }
    // organize corpus into batches for preloading
    const batchSize = 25;
    const batchedCorpus = (0, batchPreloading_1.batchTrials)(corpus, batchSize);
    const batchedMediaAssets = (0, helpers_1.batchMediaAssets)(mediaAssets, batchedCorpus, ['image', 'answer', 'distractors']);
    const initialMediaAssets = (0, batchPreloading_1.getLeftoverAssets)(batchedMediaAssets, mediaAssets);
    initialMediaAssets.images = {}; // all sds images used in the task are specifed in corpus
    const initialPreload = (0, helpers_1.createPreloadTrials)(initialMediaAssets).default;
    (0, helpers_1.initTrialSaving)(config);
    const initialTimeline = (0, helpers_1.initTimeline)(config, trials_1.enterFullscreen);
    const timeline = [initialPreload, initialTimeline];
    const buttonNoise = {
        timeline: [(0, trials_1.getAudioResponse)(mediaAssets)],
        conditional_function: () => {
            const trialType = (0, taskStore_1.taskStore)().nextStimulus.trialType;
            const assessmentStage = (0, taskStore_1.taskStore)().nextStimulus.assessmentStage;
            if ((trialType === 'something-same-2' || trialType.includes('match')) &&
                assessmentStage !== 'practice_response') {
                return true;
            }
            return false;
        },
    };
    const feedbackBlock = {
        timeline: [(0, trials_1.feedback)(true, 'feedbackCorrect', 'feedbackNotQuiteRight')],
        conditional_function: () => {
            return ((0, taskStore_1.taskStore)().nextStimulus.assessmentStage === 'practice_response' &&
                !(0, taskStore_1.taskStore)().nextStimulus.trialType.includes('something-same-1') &&
                (0, taskStore_1.taskStore)().version === 2);
        },
    };
    const stimulusBlock = {
        timeline: [(0, taskStore_1.taskStore)().version === 2 ? (0, stimulus_1.stimulus)() : (0, legacyStimulus_1.legacyStimulus)(), feedbackBlock],
    };
    const afcBlock = {
        timeline: [(0, afcMatch_1.afcMatch)(), feedbackBlock],
    };
    const dataQualityBlock = {
        timeline: [dataQuality_1.dataQualityScreen],
        conditional_function: () => {
            return (0, taskStore_1.taskStore)().numIncorrect >= (0, taskStore_1.taskStore)().maxIncorrect && heavy;
        },
    };
    // create list of numbers of trials per block
    const { blockCountList, blockOperations } = (0, setTrialBlock_1.setTrialBlock)(false);
    const totalRealTrials = blockCountList.reduce((acc, total) => acc + total, 0);
    (0, taskStore_1.taskStore)('totalTestTrials', totalRealTrials);
    // counter for the next block to preload
    let currPreloadBatch = 0;
    // function to preload assets in batches at the beginning of each task block
    function preloadBlock() {
        timeline.push((0, helpers_1.createPreloadTrials)(batchedMediaAssets[currPreloadBatch]).default);
        currPreloadBatch++;
    }
    // functions to add trials to blocks of each type
    const updateTestDimensions = () => {
        timeline.push({ ...trials_1.setupStimulus, stimulus: '' });
        timeline.push(stimulusBlock);
    };
    const setupTrialDuration = (0, taskStore_1.taskStore)().version === 2 ? 0 : 350;
    const updateSomethingSame = () => {
        timeline.push({ ...trials_1.setupStimulus, stimulus: '', trial_duration: setupTrialDuration });
        timeline.push(stimulusBlock);
        timeline.push(buttonNoise);
        timeline.push(dataQualityBlock);
    };
    const updateMatching = () => {
        timeline.push({ ...trials_1.setupStimulus, stimulus: '', trial_duration: setupTrialDuration });
        timeline.push(afcBlock);
        timeline.push(buttonNoise);
        timeline.push(dataQualityBlock);
    };
    // map of block operation functions
    const blockFunctions = {
        updateTestDimensions,
        updateSomethingSame,
        updateMatching,
    };
    let trialCount = 0;
    // add trials to timeline according to block structure defined in blockOperations
    blockCountList.forEach((count, index) => {
        // push in trials
        for (let i = 0; i < count; i += 1) {
            // preload assets
            if (trialCount % batchSize === 0) {
                preloadBlock();
            }
            blockFunctions[blockOperations[index]]();
            trialCount++;
        }
    });
    (0, taskSetup_2.initializeCat)();
    timeline.push((0, trials_1.taskFinished)());
    timeline.push(trials_1.exitFullscreen);
    return { jsPsych: taskSetup_1.jsPsych, timeline };
}
